import {
  FakePageData,
  FakePageDataItems,
  SelectorFakeDataValuePair,
} from 'InternalLibrary';
import {
  generateAddress,
  generateCity,
  generateDNI,
  generateEmail,
  generateFirstName,
  generateLastName,
  generateMiddleName,
  generateNumber,
  generatePassword,
  generatePhoneNumber,
  generatePostalCode,
  generateProvince,
} from './fakeDataGenerators';
import { routes } from '../routes';

const fakeData = (route: string): FakePageDataItems => {
  let fill: SelectorFakeDataValuePair[] = [];
  let customButtons: FakePageDataItems = {};

  let submitCto: string = '[data-test="css-Continue-Button"]';

  switch (route) {
    case routes.FirstLoan_Email:
      fill = [
        ['#email', generateEmail],
        ['#phone', generatePhoneNumber],
        ['[name="agreements.firstAgreement"]', 'checkbox'],
        ['[name="agreements.secondAgreement"]', 'checkbox'],
        ['[name="agreements.thirdAgreement"]', 'checkbox'],
      ];
      break;
    case routes.FirstLoan_Confirmation:
      fill = [
        ['#id', generateDNI],
        ['#password', generatePassword],
      ];
      submitCto = '[data-test="xpath-Create-Account-Button"]';
      break;
    case routes.FirstLoan_PersonalData:
      fill = [
        ['#firstName', generateFirstName],
        ['#firstSurname', generateLastName],
        ['#secondSurname', generateMiddleName],
        ['[data-test="xpath-Day"]', () => generateNumber(1, 28)],
        ['[data-test="xpath-Month"]', () => generateNumber(1, 12)],
        ['[data-test="xpath-Year"]', () => generateNumber(1947, 2001)],
      ];
      customButtons = {
        'Young-user': [
          ...fill,
          ['[data-test="xpath-Day"]', '28'],
          ['[data-test="xpath-Month"]', '12'],
          ['[data-test="xpath-Year"]', '2001'],
        ],
        'Classic-user': [
          ...fill,
          ['[data-test="xpath-Day"]', () => generateNumber(1, 28)],
          ['[data-test="xpath-Month"]', () => generateNumber(1, 12)],
          ['[data-test="xpath-Year"]', () => generateNumber(1947, 2001)],
        ],
        'Too-old-user': [
          ...fill,
          ['[data-test="xpath-Day"]', '1'],
          ['[data-test="xpath-Month"]', '1'],
          ['[data-test="xpath-Year"]', '1942'],
        ],
      };
      break;
    case routes.FirstLoan_Address:
      fill = [
        ['#address', generateAddress],
        ['#number', () => generateNumber(1, 99)],
        ['#postalCode', generatePostalCode],
        ['[name=province]', generateProvince],
        ['#city', generateCity],
      ];
      break;
    case routes.FirstLoan_Income:
      fill = [
        ['[name="incomeSource"]', 'Military, police, civil guard'],
        ['[name="averageMonthlyIncome"]', '1200'],
      ];
      customButtons = {
        'Unapproved-user': [
          ['[name="incomeSource"]', 'Term contract (private sector)'],
          ['[name="averageMonthlyIncome"]', '00'],
        ],
      };
      break;
    case routes.FirstLoan_PhoneVerification:
      fill = [
        ['[name="verificationCode0"]', '1'],
        ['[name="verificationCode1"]', '2'],
        ['[name="verificationCode2"]', '3'],
        ['[name="verificationCode3"]', '4'],
      ];
      break;
    case routes.FirstLoan_PhoneVerification_ChangePhone:
      fill = [['[name="phoneNumber"]', generatePhoneNumber]];
      break;
    default:
      break;
  }

  const allButtons: FakePageDataItems = {
    fill: fill,
    ...customButtons,
  };

  const allButtonsAndSubmit: { [key: string]: SelectorFakeDataValuePair[] } =
    {};

  (Object.keys(allButtons) as Array<keyof typeof allButtons>).forEach(
    (buttonKey) => {
      const buttonData = allButtons[buttonKey];

      allButtonsAndSubmit[buttonKey] = [...buttonData, [submitCto, 'button']];
    },
  );
  return allButtonsAndSubmit;
};

const routesWithTestingTool = [
  routes.FirstLoan_Email,
  routes.FirstLoan_Confirmation,
  routes.FirstLoan_PersonalData,
  routes.FirstLoan_Address,
  routes.FirstLoan_Income,
  routes.FirstLoan_PhoneVerification,
  routes.FirstLoan_PhoneVerification_ChangePhone,
  routes.FirstLoan_PhoneVerification_ChangePhone,
];

export const fakeDataConfig: FakePageData[] = routesWithTestingTool.map(
  (route: string) => ({
    url: route,
    items: fakeData(route),
  }),
);
